var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "idea",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39810",
    "data-name": "Group 39810",
    transform: "translate(9.455 9.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39809",
    "data-name": "Group 39809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36939",
    "data-name": "Path 36939",
    d: "M129.047,121.3a10.428,10.428,0,0,0-7.695,7.581,10.584,10.584,0,0,0,2.833,10.2,5.687,5.687,0,0,1,1.525,4.014v.252a3.507,3.507,0,0,0,1.172,2.618v2.07a3.52,3.52,0,0,0,3.516,3.516h2.344a3.52,3.52,0,0,0,3.516-3.516v-2.07a3.507,3.507,0,0,0,1.172-2.618V143.1a5.879,5.879,0,0,1,1.607-4.091,10.554,10.554,0,0,0-9.988-17.7Zm4.866,26.737a1.173,1.173,0,0,1-1.172,1.172H130.4a1.173,1.173,0,0,1-1.172-1.172v-1.172h4.687Zm3.463-10.69a8.156,8.156,0,0,0-2.291,5.746v.256a1.173,1.173,0,0,1-1.172,1.172h-4.687a1.173,1.173,0,0,1-1.172-1.172V143.1a7.956,7.956,0,0,0-2.228-5.688,8.261,8.261,0,0,1-2.2-7.967,8.064,8.064,0,0,1,5.952-5.861,8.21,8.21,0,0,1,7.8,13.765Z",
    transform: "translate(-121.024 -121.012)",
    fill: "#06a77d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39812",
    "data-name": "Group 39812",
    transform: "translate(5.57 5.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39811",
    "data-name": "Group 39811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36940",
    "data-name": "Path 36940",
    d: "M76.609,74.952l-3.315-3.315A1.172,1.172,0,0,0,71.637,73.3l3.315,3.315a1.172,1.172,0,0,0,1.657-1.657Z",
    transform: "translate(-71.294 -71.294)",
    fill: "#06a77d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39814",
    "data-name": "Group 39814",
    transform: "translate(0 18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39813",
    "data-name": "Group 39813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36941",
    "data-name": "Path 36941",
    d: "M5.938,241H1.172a1.172,1.172,0,0,0,0,2.344H5.938a1.172,1.172,0,0,0,0-2.344Z",
    transform: "translate(0 -241)",
    fill: "#06a77d"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39816",
    "data-name": "Group 39816",
    transform: "translate(32.891 18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39815",
    "data-name": "Group 39815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36942",
    "data-name": "Path 36942",
    d: "M426.937,241h-4.766a1.172,1.172,0,0,0,0,2.344h4.766a1.172,1.172,0,0,0,0-2.344Z",
    transform: "translate(-421 -241)",
    fill: "#06a77d"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39818",
    "data-name": "Group 39818",
    transform: "translate(28.772 5.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39817",
    "data-name": "Group 39817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36943",
    "data-name": "Path 36943",
    d: "M373.595,71.638a1.172,1.172,0,0,0-1.657,0l-3.315,3.315a1.172,1.172,0,0,0,1.657,1.657l3.315-3.315A1.172,1.172,0,0,0,373.595,71.638Z",
    transform: "translate(-368.279 -71.294)",
    fill: "#06a77d"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39820",
    "data-name": "Group 39820",
    transform: "translate(18.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39819",
    "data-name": "Group 39819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36944",
    "data-name": "Path 36944",
    d: "M242.172,0A1.172,1.172,0,0,0,241,1.172V5.938a1.172,1.172,0,0,0,2.344,0V1.172A1.172,1.172,0,0,0,242.172,0Z",
    transform: "translate(-241)",
    fill: "#06a77d"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39822",
    "data-name": "Group 39822",
    transform: "translate(14.298 14.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39821",
    "data-name": "Group 39821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36945",
    "data-name": "Path 36945",
    d: "M188.72,181a6.4,6.4,0,0,0-1.458.171,5.781,5.781,0,0,0-4.209,4.139,1.172,1.172,0,1,0,2.275.564,3.432,3.432,0,0,1,2.468-2.421,4.063,4.063,0,0,1,.924-.11,1.172,1.172,0,0,0,0-2.344Z",
    transform: "translate(-183.018 -181)",
    fill: "#06a77d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.39bd386a7631bcee559e0bb3f936b32b.svg";
export { ForwardRef as ReactComponent };